
import { fetch } from '@nackle/umbrella';
import { useEffect } from 'react';
import { currentEnv, eventProxyUrl } from 'endpoints';
import { Session } from '@nackle/arcade-core-v2';
import { useSelector } from 'react-redux';
import { TRACKED_ENTRY_SOURCES } from './constants';

const UI_INTERACTION_TOPIC = `${ currentEnv || 'prod' }-ui-interaction`;


function safeBase64Decode( str ) {
  if ( !str ) {return '';}
  // Pad string to length multiple of 4
  let s = str.replace( /-/g, '+' ).replace( /_/g, '/' );
  while ( s.length % 4 ) {s += '=';}
  try {
    return atob( s );
  } catch {
    return '';
  }
}

function extractSessionId( { accessToken, user, isUmbrella } ) {
  if ( isUmbrella && user && user.session_id ) {return user.session_id;}
  if ( !accessToken ) {return '';}
  try {
    const payload = accessToken.split( '.' )[ 1 ];
    if ( !payload ) {return '';}
    const decoded = JSON.parse( safeBase64Decode( payload ) );
    return decoded && decoded.sid ? decoded.sid : '';
  } catch {
    return '';
  }
}

export const SourceTracker = ( props ) => {
  const { user, isUmbrella } = props;
  const isAuthenticated = useSelector( ( state ) => Session.isAuthenticated( state ) );
  const accessToken = useSelector( ( state ) => Session.getSessionId( state ) );
  const sessionId = extractSessionId( { accessToken, user, isUmbrella } );
  const companyId = useSelector( ( state ) => Session.getCompanyId( state ) );
  const personId = useSelector( ( state ) => Session.getPersonId( state ) );
  useEffect( () => {
    if ( !isAuthenticated || !sessionId ) {return;}
    const source = getTrackedEntrySource();
    if ( !source ) {return;}
    trackEntrySource( {
      source,
      sessionId,
      companyId,
      personId,
    } ).catch( error => {
      console.error( 'Failed to track entry source:', error );
    } );
  }, [ isAuthenticated, sessionId, companyId, personId, isUmbrella, user ] );
  return null;
};

export function getTrackedEntrySource( search = window.location.search ) {
    const source = new URLSearchParams( search ).get( 'source' );

    if ( !source ) {
        return null;
    }

    const normalizedSource = source.trim().toLowerCase();
    return TRACKED_ENTRY_SOURCES.has( normalizedSource ) ? normalizedSource : null;
}


export async function trackEntrySource( { source, sessionId, companyId, personId } ) {
    const eventData = {
        timestamp: Date.now(),
        application: 'web-event-proxy',
        sessionId,
        companyId,
        sessionPersonId: personId,
        interactionLocation: 'ARCADE',
        interaction: 'CLICK',
        action: 'LANDING_ARCADE',
        domReference: 'app-load',
        metadata: JSON.stringify( {
            source,
            currentPath: window.location.pathname,
            search: window.location.search,
        } ),
    };

    const response = await fetch( `${ eventProxyUrl }/topics`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify( {
            eventData,
            topicName: UI_INTERACTION_TOPIC,
        } ),
    } );

    if ( !response.ok ) {
        throw new Error( `Failed to track entry source: ${ response?.status }` );
    }

    return response.json();
}